import {ExceptionsClient} from "../client/ExceptionsClient";

export async function fetchExceptionShipments(params) {
    var exceptionShipments = [];
    var paginationKey = null;
    do {
        const exceptions = await getExceptionShipmentsCall(params, paginationKey).then((response) => {
            return response;
        });
        exceptionShipments = exceptionShipments.concat(exceptions.shipments);
        paginationKey = exceptions.pagination;
    } while (paginationKey !== null);
    return {valid: true, data: exceptionShipments};
}

const getExceptionShipmentsCall = async (params, paginationKey) => {
    return await ExceptionsClient.getExceptionShipments({...params, "paginationKey": paginationKey})
        .then(({valid, data}) => {
            if (valid) {
                return {shipments: data.exceptionShipments || [], pagination: data.paginationKey};
            } else {
                return {shipments: [], pagination: null};
            }
        })
};


// WEBPACK FOOTER //
// ./src/commons/api/ExceptionShipmentsAPI.js